module.exports = __webpack_public_path__ + "vue/img/chi.68d15103.png";